export default "__VITE_ASSET__C$zw$r0e__"